import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import WithRender from '@/Pages/Admin/Modules/Invoices/Views/invoices-details.html';
import {trekService} from '@/Pages/Admin/Modules/ManagePackage/Services/Trekservice';
import {common} from '@/Pages/Admin/Modules/Common/Services/Common';
import {flashService} from '@/Pages/Admin/Modules/Common/Services/FlashMessage/FlashService';

@WithRender
@Component({
    components: {}
})
export default class InvoicesDetails extends Vue {
    protected ui: any = {};
    protected errors: any = {};
    protected isError: boolean = false;
    protected invoiceDetails:any={};
    protected fromDetails:any={};

    protected errorsMessage: any = {};


    constructor() {
        super();
        this.ui.IsLoading = false;
        this.ui.PostLoading = false;
    }

    public mounted() {
        this.getInvoiceDetails();
        this.getInvoiceFromDetails();

    }
    
    public getInvoiceDetails() {
        let data = {
            uuid: this.$route.query.uuid,
        };
        this.ui.IsLoading = true;
        trekService
            .InvoiceDetailView(data)
            .then((res: any) => {
                this.ui.IsLoading = false;
                this.invoiceDetails = res.data.data;
                console.log("msg",res.data.data);
            })
            .catch((error: any) => {
                common.sdCatchErr(error, this.errorsMessage).then((res: any) => {
                    this.isError = true;
                    this.errorsMessage = res;
                });
            });
    }

    public getInvoiceFromDetails() {
        this.ui.IsLoading = true;
        trekService
            .InvoiceFromDetail()
            .then((res: any) => {
                this.ui.IsLoading = false;
                this.fromDetails = res.data.data;
               
                
            })
            .catch((error: any) => {
                common.sdCatchErr(error, this.errorsMessage).then((res: any) => {
                    this.isError = true;
                    this.errorsMessage = res;
                });
            });

    }
    protected redirectToInvoicehistory() {
        this.$router.push({
            name: 'user-invoice',
            query: {
                uuid: this.$route.query.uuid,
            },
        });
    }
}